// @owners { team: patients }
import { type ReduxStateShared } from '~shared/types';

const getPendingRating = (state: ReduxStateShared) => state.rateShipment.pendingRating;

export default getPendingRating;
